export const CVALUES = {
    CONTENT_TYPE_JSON: 'application/json;charset=utf-8',
    CONTENT_TYPE_FORM: 'multipart/form-data',
    VERSION: '9',
    SVNURL: false,
    ENABLETICKET: false
};
